import Form from './Form';
import React, { useEffect, useState } from 'react';
import Badge from '@mui/material/Badge';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import FilterAltRoundedIcon from '@mui/icons-material/FilterAltRounded';

import { FormattedMessage } from 'react-intl';
import { NewDialog, NewDialogActions, NewDialogContent, NewDialogTitle } from 'components';

const filters = (data) => {
  const f = Object.values(data).filter((x) => {
    if (typeof x === 'object') {
      if (x.length > 0) {
        return x;
      }
      return undefined;
    }
    return x;
  });
  return f.length;
};

export default function CreatePopup({ init, title = 'فیلتر', setFilter, clearFilter }) {
  const [count, setCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [formError, setFormError] = useState(true);

  const onOpen = () => {
    setOpen(true);
    setFormData(init);
  };
  const onClose = () => {
    setOpen(false);
  };

  const onChange = ({ formData, errors }) => {
    setFormData(formData);
    setFormError(Boolean(errors.length > 0));
  };

  const onSubmit = () => {
    setCount(filters(formData));
    setFilter(formData);
    onClose();
  };

  useEffect(() => {
    setCount(filters(init));
  }, [init]);

  // useEffect(() => {
  //   open && setFilter(init);
  //   // console.log(init);
  // }, [open]);

  return (
    <>
      <Badge
        // variant="dot"
        color="warning"
        overlap="circular"
        // invisible={invisible}
        badgeContent={count}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <IconButton size="small" color="warning" onClick={onOpen} sx={{ bgcolor: 'action.hover' }}>
          <FilterAltRoundedIcon fontSize="small" />
        </IconButton>
      </Badge>
      <IconButton size="small" onClick={clearFilter} sx={{ bgcolor: 'action.hover' }}>
        <CloseRoundedIcon fontSize="small" />
      </IconButton>
      <NewDialog label="create" open={open} onClose={onClose}>
        <NewDialogTitle title={title} onClose={onClose} />
        <NewDialogContent isPopup>
          <Stack p={1} flex={2} rowGap={1} bgcolor="background.paper">
            <Form formData={formData} onChange={onChange} />
          </Stack>
        </NewDialogContent>
        <NewDialogActions>
          <Button
            autoFocus
            size="large"
            color="primary"
            variant="contained"
            onClick={onSubmit}
            sx={{ minWidth: 80 }}
            // disabled={formError}
          >
            <FormattedMessage id="create" />
          </Button>
        </NewDialogActions>
      </NewDialog>
    </>
  );
}
